import { b2bCampaignTypeChoices } from '@sh4res/bo-common/components/B2bCampaigns/choices';

import { makeChoices } from '@Utils/makeChoices';

export const collectiveOperationTypeChoices = [
  ...b2bCampaignTypeChoices,
  ...makeChoices<'matching_contribution' | 'ccb_withdrawal'>({
    matching_contribution:
      'resources.bo_external.collective_operations.choices.type.matching_contribution',
    ccb_withdrawal: 'resources.bo_external.collective_operations.choices.type.ccb_withdrawal',
  }),
];
